module.exports = __webpack_public_path__ + "static/media/career_category.6650b1d4.jpg";